// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container for all plans */
.plans-container {
	position: relative;
	margin-top: 0px;
	margin-bottom: 50px;
    align-items: center;
	justify-content: center;
	place-content: center;
	border-radius: 12px; /* Rounded corners */
	box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.08); /* Directional shadow towards the bottom */
	transition: all 0.3s ease; /* Smooth transition for micro-interactions */
}

/* Individual Plan Card */
.plan-card {
	padding: 25px;
	border-radius: 12px; /* Rounded corners */
	box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.06); /* Directional shadow towards the bottom */
	transition: all 0.3s ease; /* Smooth transition for micro-interactions */
}



.plan-price-label {
	font-weight: medium;
	text-align: start;
	font-size: 40px;
}

.plan-currency-label {
	font-weight: medium;
	text-align: start;
	font-size: 40px;
}

.plan-button{
	align-items: center;
	border-radius: 8px;
}

/* Plan Description */
.plan-description {
	color: #535353;
	max-lines: 2 !important;
	max-width: 100% !important;
	text-overflow: ellipsis !important;
}

.plan-text{
	font-size: 12px;

}

/* Media Query for smaller screens */
@media (max-width: 576px) {
	.plans-container {
		margin-top: -60px;
	}
}

/* Micro-interactions: Hover effect for the plan card */
.plan-card:hover {
	transform: scale(1.05); /* Slightly enlarge the card */
	box-shadow: 0px 8px 18px rgba(0, 0, 0, 0.1); /* Deeper shadow on hover */
}

/* Micro-interactions: Hover effect for the plans container */
.plans-container:hover {
	box-shadow: 0px 10px 24px rgba(0, 0, 0, 0.1); /* Deeper shadow on hover */
}
`, "",{"version":3,"sources":["webpack://./src/app/shared-components/plan-card/plan-card.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;CACC,kBAAkB;CAClB,eAAe;CACf,mBAAmB;IAChB,mBAAmB;CACtB,uBAAuB;CACvB,qBAAqB;CACrB,mBAAmB,EAAE,oBAAoB;CACzC,4CAA4C,EAAE,0CAA0C;CACxF,yBAAyB,EAAE,6CAA6C;AACzE;;AAEA,yBAAyB;AACzB;CACC,aAAa;CACb,mBAAmB,EAAE,oBAAoB;CACzC,4CAA4C,EAAE,0CAA0C;CACxF,yBAAyB,EAAE,6CAA6C;AACzE;;;;AAIA;CACC,mBAAmB;CACnB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,mBAAmB;CACnB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA,qBAAqB;AACrB;CACC,cAAc;CACd,uBAAuB;CACvB,0BAA0B;CAC1B,kCAAkC;AACnC;;AAEA;CACC,eAAe;;AAEhB;;AAEA,oCAAoC;AACpC;CACC;EACC,iBAAiB;CAClB;AACD;;AAEA,uDAAuD;AACvD;CACC,sBAAsB,EAAE,8BAA8B;CACtD,2CAA2C,EAAE,2BAA2B;AACzE;;AAEA,6DAA6D;AAC7D;CACC,4CAA4C,EAAE,2BAA2B;AAC1E","sourcesContent":["/* Container for all plans */\n.plans-container {\n\tposition: relative;\n\tmargin-top: 0px;\n\tmargin-bottom: 50px;\n    align-items: center;\n\tjustify-content: center;\n\tplace-content: center;\n\tborder-radius: 12px; /* Rounded corners */\n\tbox-shadow: 0px 8px 20px rgba(0, 0, 0, 0.08); /* Directional shadow towards the bottom */\n\ttransition: all 0.3s ease; /* Smooth transition for micro-interactions */\n}\n\n/* Individual Plan Card */\n.plan-card {\n\tpadding: 25px;\n\tborder-radius: 12px; /* Rounded corners */\n\tbox-shadow: 0px 6px 15px rgba(0, 0, 0, 0.06); /* Directional shadow towards the bottom */\n\ttransition: all 0.3s ease; /* Smooth transition for micro-interactions */\n}\n\n\n\n.plan-price-label {\n\tfont-weight: medium;\n\ttext-align: start;\n\tfont-size: 40px;\n}\n\n.plan-currency-label {\n\tfont-weight: medium;\n\ttext-align: start;\n\tfont-size: 40px;\n}\n\n.plan-button{\n\talign-items: center;\n\tborder-radius: 8px;\n}\n\n/* Plan Description */\n.plan-description {\n\tcolor: #535353;\n\tmax-lines: 2 !important;\n\tmax-width: 100% !important;\n\ttext-overflow: ellipsis !important;\n}\n\n.plan-text{\n\tfont-size: 12px;\n\n}\n\n/* Media Query for smaller screens */\n@media (max-width: 576px) {\n\t.plans-container {\n\t\tmargin-top: -60px;\n\t}\n}\n\n/* Micro-interactions: Hover effect for the plan card */\n.plan-card:hover {\n\ttransform: scale(1.05); /* Slightly enlarge the card */\n\tbox-shadow: 0px 8px 18px rgba(0, 0, 0, 0.1); /* Deeper shadow on hover */\n}\n\n/* Micro-interactions: Hover effect for the plans container */\n.plans-container:hover {\n\tbox-shadow: 0px 10px 24px rgba(0, 0, 0, 0.1); /* Deeper shadow on hover */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
